<template>
  <div id="post-comment">
    <div class="comment-head">
      <div class="comment-headline">
        <el-icon>
          <ChatRound />
        </el-icon>
        <span>留言</span>
      </div>
    </div>
    <div class="comment-wrap">
      <div id="twikoo" class="twikoo"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'TwikooComment',
  props: {
    // Twikoo 环境 ID
    envId: {
      type: String,
      required: true
    },
    // 页面路径，用于区分不同页面的评论
    path: {
      type: String,
      default: () => window.location.pathname
    }
  },
  setup(props) {
    onMounted(() => {
      window.twikoo.init({
        envId: props.envId, // 腾讯云环境填 envId；Vercel 环境填地址（https://xxx.vercel.app）
        el: '#twikoo', // 容器元素
        path: props.path // 用于区分不同文章的自定义路径
      })
    })
  }
})
</script>

<style>
#post-comment {
  margin-top: 2rem;
  width: 100%;
}
/* 响应式适配（移动端） */
@media screen and (max-width: 768px) {
  #post-comment {
    width: 90vw;
  }
}

div#post-comment {
  margin-top: 2rem;
}

#post-comment>div.comment-head>div.comment-privacy {
  margin-left: 8px;
  font-size: 13px;
}

#post-comment>div.comment-head>div.comment-privacy a:hover {
  color: var(--adil-theme);
}

#post-comment .comment-tips {
  background-color: rgba(103, 194, 58, 0.13);
  border: var(--style-border-always);
  border-color: var(--adil-green);
  color: var(--adil-green);
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 0.5rem;
  display: none;
  width: 100%;
}


#post-comment .comment-tips.show {
  display: flex;
  font-weight: bold;
}

.comment-head {
  font-size: 0.8em !important;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.comment-randomInfo {
  margin-left: auto;
  font-size: 13px;
}

.comment-randomInfo:hover a {
  color: var(--adil-theme);
}

.tk-row .tk-avatar {
  display: none;
}

.comment-headline {
  display: inline-block;
  vertical-align: middle;
  font-weight: 700;
  font-size: 20px;
}

.tk-avatar {
  flex-shrink: 0;
  overflow: hidden;
  text-align: center;
  border-radius: 32px;
  width: 32px !important;
  height: 32px !important;
  box-shadow: var(--adil-shadow-border);
  margin-right: 16px !important;
}

.img.tk-avatar-img {
  height: 32px !important;
  border-radius: 32px;
  border: var(--style-border-always);
}

.tk-avatar .tk-avatar-img:hover {
  transform: rotate(360deg);
}

.tk-comment .tk-submit .tk-avatar,
.tk-replies .tk-avatar {
  height: 1.6rem;
  width: 1.6rem;
}

.tk-avatar.tk-has-avatar {
  background-color: rgba(144, 147, 153, 0.13);
  width: 32px;
  height: 32px;
  border-radius: 32px;

}

.tk-avatar.tk-clickable {
  cursor: pointer;
}

.tk-avatar .tk-avatar-img {
  height: 2.5rem;
  color: #c0c4cc;
}

.tk-comment .tk-submit .tk-avatar .tk-avatar-img,
.tk-replies .tk-avatar .tk-avatar-img {
  height: 1.6rem;
}




.tk-meta-input .el-input {
  width: auto;
  width: calc((100% - 1rem) / 3);
  /* Fix Safari */
  flex: 1;
  box-shadow: var(--adil-shadow-border);
}

.tk-meta-input .el-input+.el-input {
  margin-left: 0.5rem;
}

.tk-meta-input .el-input .el-input-group__prepend {
  padding: 0 1rem;
}

.tk-meta-input .el-input input:invalid {
  border: 1px solid #f56c6c;
  box-shadow: none;
}

@media screen and (max-width: 767px) {
  .tk-meta-input {
    flex-direction: column;
  }

  .tk-meta-input .el-input {
    width: auto;
  }

  .tk-meta-input .el-input+.el-input {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}

#twikoo>div.tk-comments>div.tk-submit>div.tk-row.actions>a {
  display: none !important;
}

.tk-meta {
  display: flex;
  align-items: center;
}

.tk-submit {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.tk-row {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.tk-col {
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
}

.tk-meta-input {
  margin-bottom: 0.5rem;
  position: relative;
  margin-top: 0.8rem;
  width: calc(100% - 5.5rem);

}

.tk-row.actions {
  position: relative;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-left: 0px;
  margin-top: 0.5rem;
  justify-content: space-around;

}

.tk-row-actions-start {
  flex: 1;
  display: flex;
  align-items: center;
  position: absolute;
  top: -100px;
  left: 17px;
}

.tk-comments .el-button--primary.is-disabled,
.tk-comments .el-button--primary.is-disabled:active,
.tk-comments .el-button--primary.is-disabled:focus,
.tk-comments .el-button--primary.is-disabled:hover {
  opacity: 0.4;
}

.tk-submit-action-icon {
  align-self: center;
  display: inline-block;
  width: 1.25em;
  line-height: 0;
  margin-right: 10px;
  cursor: pointer;
  flex-shrink: 0;
}

.tk-submit-action-icon svg:hover {
  opacity: 0.8;
}

.tk-submit-action-icon.__markdown {
  color: #909399;
  display: none;
}

button.el-button.tk-cancel.el-button--default.el-button--small {
  background: var(--adil-secondbg) !important;
  border-radius: 8px !important;
  color: var(--adil-fontcolor) !important;
}

.tk-action-icon svg {
  fill: var(--adil-lighttext) !important;
}

.tk-error-message {
  word-break: break-all;
  color: #ff0000;
  font-size: 0.75em;
  flex-shrink: 1;
}

.tk-input-image {
  display: none;
}

.tk-input {
  flex: 1;
}

.el-button.tk-preview {
  display: none;
}

.tk-input .el-textarea__inner {
  background-position: right bottom;
  background-repeat: no-repeat;
}

.tk-turnstile-container {
  position: absolute;
  right: 0;
  bottom: -75px;
  z-index: 1;
}

.tk-turnstile {
  display: flex;
  flex-direction: column;
}

.tk-preview-container {
  margin-left: 3rem;
  margin-bottom: 1rem;
  padding: 5px 15px;
  border: 1px solid rgba(128, 128, 128, 0.31);
  border-radius: 4px;
  word-break: break-word;
}

.tk-fade-in {
  animation: tkFadeIn .3s;
}

@keyframes tkFadeIn {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}


.tk-action {
  display: flex;
  align-items: center;
}

.tk-action-link {
  margin-left: 0.5rem;
  color: var(--adil-lighttext);
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.tk-action-link .tk-action-icon-solid {
  display: none;
}

.tk-action-link.tk-liked .tk-action-icon,
.tk-action-link:hover .tk-action-icon {
  display: none;
}

.tk-action-link.tk-liked .tk-action-icon-solid,
.tk-action-link:hover .tk-action-icon-solid {
  display: block;
}

.tk-action-count {
  margin-left: 0.25rem;
  font-size: 0.75rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.tk-action-icon {
  display: inline-block;
  height: 1em;
  width: 1em;
  line-height: 0;
  color: #409eff;
}


.tk-main {
  flex: 1;
  width: 0;
}

.tk-nick-link {
  color: inherit;
  text-decoration: none;
}

.tk-replies .tk-nick-link {
  font-size: .9em;
}

.tk-nick {
  font-size: 1rem !important;
  line-height: 32px;
}

.el-input.el-input--small.el-input-group.el-input-group--prepend::after {
  display: none;
  content: '';
  position: absolute;
  border: 12px solid transparent;
  border-top-color: #444;
  left: 50%;
  transform: translate(-50%, -46px);
}

.el-input.el-input--small.el-input-group.el-input-group--prepend::before {
  /* 先隐藏起来 */
  display: none;
  /* 绝对定位 */
  position: absolute;
  /* 向上移动60像素 */
  top: -60px;
  /* 文字强制不换行，防止left:50%导致的文字换行 */
  white-space: nowrap;
  /* 圆角 */
  border-radius: 10px;
  /* 距离左边50% */
  left: 50%;
  /* 然后再向左边挪动自身的一半，即可实现居中 */
  transform: translate(-50%);
  /* 填充 */
  padding: 14px 18px;
  background: #444;
  color: #fff;
  z-index: 100;
}

/* 评论输入框提示 */
/* 设置文字内容 :nth-child(1)的作用是选择第几个 */
.el-input.el-input--small.el-input-group.el-input-group--prepend:nth-child(1):before {
  content: '输入QQ号会自动获取昵称和头像';
}

.el-input.el-input--small.el-input-group.el-input-group--prepend:nth-child(2):before {
  content: '收到回复将会发送到你的邮箱';
}

.el-input.el-input--small.el-input-group.el-input-group--prepend:nth-child(3):before {
  content: '可以通过昵称访问你的网站';
}

/* 当用户点击输入框时显示 */
.el-input.el-input--small.el-input-group.el-input-group--prepend:focus-within::before {
  display: block;
  animation: commonTipsIn 0.3s;
}

.el-input.el-input--small.el-input-group.el-input-group--prepend:focus-within::after {
  display: block;
  animation: commonTriangleIn 0.3s;
}

@keyframes commonTipsIn {
  0% {
    top: -50px;
    opacity: 0;
  }

  100% {
    top: -60px;
    opacity: 1;
  }
}

@keyframes commonTriangleIn {
  0% {
    transform: translate(-50%, -36px);
    opacity: 0;
  }

  100% {
    transform: translate(-50%, -46px);
    opacity: 1;
  }
}


.tk-actions {
  display: none;
  margin-left: 1em;
}

.tk-comment:hover .tk-actions {
  display: inline;
}

.tk-extra .tk-icon {
  display: none;
}

.tk-extras {
  color: #999999;
  font-size: 0.875em;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.tk-extra {
  align-items: center;
  background: var(--adil-card-bg);
  border: var(--style-border-always);
  padding: 1px 5px 1px 2px;
  border-radius: 8px;
  margin-right: 4px !important;
  color: var(--adil-secondtext) !important;
  display: inline !important;
  margin-top: 6px !important;
  font-size: 0.5rem;
}

.tk-icon.__comment {
  height: 1em;
  width: 1em;
  line-height: 1;
}

.tk-icon {
  position: absolute
}

.tk-extra-text {
  line-height: 1;
}

.tk-tag {
  display: inline-block;
  padding: 0 0.5em;
  font-size: 0.75em;
  background-color: #f2f6fc;
}

.tk-tag-green {
  border-radius: 4px !important;
  border: 0px solid #e1f3d8 !important;
  font-size: 0.5rem !important;
}

.tk-time {
  color: var(--adil-secondtext) !important;
  font-size: 0.6rem;
  margin-left: 0.5rem;
}

.tk-action .tk-action-link:first-child {
  display: none;
}

.tk-tag-yellow {
  background-color: rgba(230, 162, 60, 0.13);
  color: #e6a23c;
  border-radius: 4px !important;
  border: 0px solid #e1f3d8 !important;
  font-size: 0.5rem !important
}

.tk-tag-blue {
  background-color: rgba(64, 158, 255, 0.13);
  border: 1px solid rgba(64, 158, 255, 0.50);
  border-radius: 2px;
  color: #409eff;
}

.tk-tag-red {
  background-color: rgba(245, 108, 108, 0.13);
  color: #f56c6c;
  border-radius: 4px !important;
  border: 0px solid #f3d8d8 !important;
  font-size: 0.5rem !important;
}

.tk-comment {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  word-break: break-all;
}

.tk-content {
  margin-top: 0.5rem;
  overflow: hidden;
  max-height: 500px;
  position: relative;
}

.tk-tag tk-tag-green {
  display: none;
}

.tk-content-expand {
  max-height: none;
}

.tk-replies .tk-content {
  font-size: .9em;
}

.tk-comment .vemoji {
  max-height: 2em;
  vertical-align: middle;
}

.tk-replies {
  max-height: 200px;
  overflow: hidden;
  position: relative;
}

.tk-replies-expand {
  max-height: none;
  overflow: unset;
}





.tk-lightbox {
  display: block;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.tk-lightbox-image {
  min-width: 100px;
  min-height: 30px;
  width: auto;
  height: auto;
  max-width: 95%;
  max-height: 95%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(90deg, #eeeeee 50%, #e3e3e3 0);
  background-size: 40px 100%;
}


.tk-comments-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
}

@media screen and (max-width: 768px) {
  .tk-submit .el-button--primary {
    width: 5rem;
    height: 132px;
    top: -161px;
  }

  .tk-row-actions-start {
    top: -210px;
  }
}

.tk-comments-count.__hidden {
  visibility: hidden;
}

.tk-comments-count {
  display: none;
}

.tk-comments-container {
  min-height: 0rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.tk-replies>.tk-comment {
  background: var(--adil-card-bg);
  border-top: var(--style-border-dashed);
  border-radius: 12px;
  transition: 0.3s;
  padding: 1rem 0 0;
  margin-top: 0;
}

.tk-comments-no {
  display: none;
}

.tk-comments-error {
  font-size: 0.75em;
  color: #ff0000;
}

.tk-icon.__comments {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: sub;
  margin-left: 0;
  height: 0.75em;
  width: 0.75em;
  line-height: 0;
  cursor: pointer;
  color: #409eff;
  position: absolute;
  left: 0;
}

.twikoo div.code-toolbar {
  position: relative;
  border-radius: .3em
}

.twikoo div.code-toolbar>.toolbar {
  position: absolute;
  right: 4px;
  top: 4px;
  font-size: .8125rem;
  font-weight: 500;
  display: flex;
}

.twikoo div.code-toolbar>.toolbar>.toolbar-item {
  margin-left: .3em
}

.twikoo div.code-toolbar>.toolbar>.toolbar-item>a,
.twikoo div.code-toolbar>.toolbar>.toolbar-item>button,
.twikoo div.code-toolbar>.toolbar>.toolbar-item>span {
  padding: 2px 4px;
  border-radius: .3em;
}

.twikoo div.code-toolbar>.toolbar>.toolbar-item>button {
  border: 1px solid rgba(128, 128, 128, 0.31);
}

.twikoo div.code-toolbar>.toolbar>.toolbar-item>button:hover {
  cursor: pointer;
}


.tk-footer {
  display:none;
  width: 100%;
  text-align: end;
  font-size: 0.75em;
  color: #999999;
  margin-top: 1em;
}


.tk-pagination,
.tk-pagination-pagers {
  display: flex;
}

.tk-pagination {
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.tk-pagination-options {
  display: flex;
  align-items: center;
}

.tk-pagination-pager {
  width: 2em;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tk-pagination-pager.__current {
  background-color: #409eff;
  pointer-events: none;
}

.tk-pagination .el-input {
  width: 50px;
}

.tk-pagination .el-input .el-input__inner {
  padding: 0;
  height: 28px;
  text-align: center;
  -moz-appearance: textfield;
  appearance: textfield;
}

.tk-pagination .el-input .el-input__inner::-webkit-inner-spin-button,
.tk-pagination .el-input .el-input__inner::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}


.tk-admin-comment {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tk-admin-comment a {
  color: currentColor;
  text-decoration: underline;
}

.tk-admin-warn {
  padding: 1rem 1.5rem;
  background-color: #fff7d0;
  border-left: 0.5rem solid #e7c000;
  color: #6b5900;
  align-self: stretch;
}

.tk-admin-comment-filter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.tk-admin-comment-filter-keyword {
  flex: 1;
}

.tk-admin-comment-filter-type {
  height: 32px;
  margin: 0 0.5em;
  padding: 0 0.5em;
  color: #ffffff;
  background: none;
  border: 1px solid rgba(144, 147, 153, 0.31);
  border-radius: 4px;
  position: relative;
  -moz-appearance: none;
  appearance: none;
  -webkit-appearance: none;
}

.tk-admin-comment-filter-type:focus {
  border-color: #409eff;
}

.tk-admin-comment-filter-type option {
  color: initial;
}

.tk-admin-comment-list {
  margin-top: 1em;
}

.tk-admin-comment-list,
.tk-admin-comment-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

.tk-admin-comment-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 0.5em;
}

.tk-admin-comment .tk-avatar {
  margin-right: 0.5em;
}

.tk-admin-comment .tk-content {
  max-height: none;
}

.tk-admin-actions {
  display: flex;
  margin-bottom: 1em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}


.tk-admin-config-groups {
  overflow-y: auto;
  padding-right: 0.5em;
}

.tk-admin-config-groups .tk-admin-config-group,
.tk-admin-config-groups .tk-admin-config-group-title {
  background: transparent;
}

.tk-admin-config-group-title {
  margin-top: 1em;
  font-size: 1.25rem;
  font-weight: bold;
}

.tk-admin-config-item {
  display: grid;
  align-items: center;
  grid-template-columns: 30% 70%;
  margin-top: 1em;
}

.tk-admin-config-title {
  text-align: right;
  margin-right: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tk-admin-config-desc {
  margin-top: 0.5em;
  font-size: 0.75em;
  overflow-wrap: break-word;
}

.tk-admin-config-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1em;
}

.tk-admin-config-message {
  margin-top: 0.5em;
  text-align: center;
}

.tk-admin-config-email-test-desc {
  margin: 1em 0;
}


.tk-admin-import {
  display: flex;
  flex-direction: column;
}

.tk-admin-import-label {
  margin-top: 1em;
  font-size: 1.25rem;
  font-weight: bold;
}

.tk-admin-import select,
.tk-admin-import input,
.tk-admin-import .el-button,
.tk-admin-import .el-textarea {
  margin-top: 1em;
}


.tk-admin-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.tk-admin {
  position: absolute;
  top: 0;
  left: 100%;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  pointer-events: all;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.60);
  backdrop-filter: blur(5px);
  transition: all 0.5s ease;
  visibility: hidden;
}

.tk-admin::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}

.tk-admin::-webkit-scrollbar-track {
  background-color: transparent;
}

.tk-admin::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.31);
}

.tk-admin.__show {
  left: 0;
  visibility: visible;
}

.tk-admin-close {
  position: sticky;
  float: right;
  display: block;
  top: 0;
  right: 0;
  width: 1rem;
  height: 1rem;
  padding: 1rem;
  box-sizing: content-box;
  color: #ffffff;
}

.tk-login,
.tk-regist {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
}

.tk-login-title {
  color: #ffffff;
  font-size: 1.25rem;
  text-align: center;
  margin-top: 10rem;
}

.tk-password,
.tk-login-msg {
  color: #ffffff;
  width: 80%;
  text-align: center;
  margin-top: 1rem;
}

.tk-password .el-input__inner {
  min-width: 100px;
}

.tk-login-msg a {
  color: #ffffff;
  margin-left: 1em;
  text-decoration: underline;
}

.tk-regist-button {
  margin-top: 1rem;
}

.tk-panel {
  color: #ffffff;
  padding: 2rem;
}

.tk-panel-title {
  font-size: 1.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.tk-panel-logout {
  color: #ffffff;
  font-size: 1rem;
  text-decoration: underline;
}

.tk-panel .tk-tabs {
  display: flex;
  margin-bottom: 1em;
  border-bottom: 2px solid #c0c4cc;
}

.tk-panel .tk-tab {
  color: #c0c4cc;
  cursor: pointer;
  line-height: 2em;
  margin-right: 2em;
  margin-bottom: -2px;
}

.tk-panel .tk-tab.__active {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}


.twikoo {
  position: relative;
}

.twikoo svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}

/* 全局 CSS */
.tk-expand {
  width: 100%;
  cursor: pointer;
  padding: 0.75em;
  text-align: center;
  transition: all 0.5s;
  font-size: 0.75em;
  background: var(--adil-card-bg);
  color: var(--adil-fontcolor);
  border: var(--style-border-always);
  box-shadow: var(--adil-shadow-border);
  border-radius: 12px;
  -webkit-user-select: none;
  user-select: none;
}

.tk-expand:hover {
  background: var(--adil-theme);
  color: var(--adil-white);
}

.tk-expand:active {
  background-color: rgba(0, 0, 0, 0.19);
}

.tk-content img {
  max-width: 300px;
  max-height: 300px;
  vertical-align: middle;
}

.tk-content p {
  margin: 0px !important;
}

.tk-replies .tk-content span:first-child {
  font-size: 0.5rem;
  color: var(--adil-secondtext);
}

.tk-owo-emotion,
.twikoo .OwO-item img {
  width: 3em;
  height: auto;
}

/* element-ui overwrite */
.twikoo .el-input__inner,
.twikoo .el-textarea__inner {
  color: currentColor;
  background-color: var(--adil-card-bg);
  box-shadow: var(--adil-shadow-border);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-image: none;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

.twikoo .el-input__inner:hover,
.twikoo .el-textarea__inner:hover {
  border-color: rgba(144, 147, 153, 0.50);
}


.twikoo .el-input-group__append,
.twikoo .el-input-group__prepend {
  color: currentColor;
  background-clip: padding-box;
  background-color: rgba(144, 147, 153, 0.13);
  border-color: rgba(144, 147, 153, 0.31);
}

.twikoo .el-button:not(.el-button--primary):not(.el-button--text) {
  color: currentColor;
  background-color: rgba(144, 147, 153, 0.063);
  border-color: rgba(144, 147, 153, 0.31);
}

.twikoo .el-button:not(.el-button--primary):not(.el-button--text):active,
.twikoo .el-button:not(.el-button--primary):not(.el-button--text):focus,
.twikoo .el-button:not(.el-button--primary):not(.el-button--text):hover {
  color: var(--adil-fontcolor);
  background-color: var(--adil-fontcolor);
  border-color: rgba(64, 158, 255, 0.50);
  border: 0px solid var(--adil-main);
}

.twikoo .el-button--primary.is-disabled,
.twikoo .el-button--primary.is-disabled:active,
.twikoo .el-button--primary.is-disabled:focus,
.twikoo .el-button--primary.is-disabled:hover {
  color: rgba(255, 255, 255, 0.63);
  background-color: var(--adil-fontcolor);
  border-color: transparent;
  border: 0px solid var(--adil-main);
}

#twikoo .tk-row .tk-col {
  flex-direction: column-reverse !important;
}

.twikoo .el-loading-mask {
  backdrop-filter: opacity(20%);
  background-color: none !important;
}

#app.tk-meta-input .el-input {
  box-shadow: var(--adil-shadow-border);
}

.twikoo .el-textarea .el-input__count {
  background: transparent;
}

.el-button {
  background-color: var(--adil-fontcolor) !important;
  border: 0px solid var(--adil-main) !important;
  color: var(--adil-background) !important;
  border-radius: 8px !important;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  outline: 0;
  margin: 0;
  font-weight: 500;
}

.el-button+.el-button {
  margin-left: 10px
}

.el-button:focus,
.el-button:hover {
  background: var(--adil-main) !important;
  color: var(--adil-white) !important;
  background-color: #ecf5ff
}

.el-button:active {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0
}

.el-button::-moz-focus-inner {
  border: 0
}

.el-button [class*=el-icon-]+span {
  margin-left: 5px
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #FFF;
  border-color: #409EFF;
  color: #409EFF
}

.el-button.is-active,
.el-button.is-plain:active {
  color: #3a8ee6;
  border-color: #3a8ee6
}

.el-button.is-plain:active {
  background: #FFF;
  outline: 0
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #C0C4CC;
  cursor: not-allowed;
  background-image: none;
  background-color: #FFF;
  border-color: #EBEEF5
}

.el-button.is-disabled.el-button--text {
  background-color: transparent
}

.el-button.is-disabled.is-plain,
.el-button.is-disabled.is-plain:focus,
.el-button.is-disabled.is-plain:hover {
  background-color: #FFF;
  border-color: #EBEEF5;
  color: #C0C4CC
}

.el-button.is-loading {
  position: relative;
  pointer-events: none
}

.el-button.is-loading:before {
  pointer-events: none;
  content: '';
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, .35)
}

.el-button.is-round {
  border-radius: 20px;
  padding: 12px 23px
}

.el-button.is-circle {
  border-radius: 50%;
  padding: 12px
}

.el-button--primary {
  color: #FFF;
  background-color: var(--adil-fontcolor);
  border-color: #409EFF
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: var(--adil-theme);
  border-color: #66b1ff;
  color: #FFF
}

.el-button--primary:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #FFF;
  outline: 0
}

.el-button--primary.is-active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #FFF
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  color: #FFF;
  background-color: #a0cfff;
  border-color: #a0cfff
}

.el-button--primary.is-plain {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff
}

.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #409EFF;
  border-color: #409EFF;
  color: #FFF
}

.el-button--primary.is-plain:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #FFF;
  outline: 0
}

.el-button--primary.is-plain.is-disabled,
.el-button--primary.is-plain.is-disabled:active,
.el-button--primary.is-plain.is-disabled:focus,
.el-button--primary.is-plain.is-disabled:hover {
  color: #8cc5ff;
  background-color: #ecf5ff;
  border-color: #d9ecff
}

.el-button--success {
  color: #FFF;
  background-color: #67C23A;
  border-color: #67C23A
}

.el-button--success:focus,
.el-button--success:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #FFF
}

.el-button--success.is-active,
.el-button--success:active {
  background: #5daf34;
  border-color: #5daf34;
  color: #FFF
}

.el-button--success:active {
  outline: 0
}

.el-button--success.is-disabled,
.el-button--success.is-disabled:active,
.el-button--success.is-disabled:focus,
.el-button--success.is-disabled:hover {
  color: #FFF;
  background-color: #b3e19d;
  border-color: #b3e19d
}

.el-button--success.is-plain {
  color: #67C23A;
  background: #f0f9eb;
  border-color: #c2e7b0
}

.el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  background: #67C23A;
  border-color: #67C23A;
  color: #FFF
}

.el-button--success.is-plain:active {
  background: #5daf34;
  border-color: #5daf34;
  color: #FFF;
  outline: 0
}

.el-button--success.is-plain.is-disabled,
.el-button--success.is-plain.is-disabled:active,
.el-button--success.is-plain.is-disabled:focus,
.el-button--success.is-plain.is-disabled:hover {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8
}

.el-button--warning {
  color: #FFF;
  background-color: #E6A23C;
  border-color: #E6A23C
}

.el-button--warning:focus,
.el-button--warning:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #FFF
}

.el-button--warning.is-active,
.el-button--warning:active {
  background: #cf9236;
  border-color: #cf9236;
  color: #FFF
}

.el-button--warning:active {
  outline: 0
}

.el-button--warning.is-disabled,
.el-button--warning.is-disabled:active,
.el-button--warning.is-disabled:focus,
.el-button--warning.is-disabled:hover {
  color: #FFF;
  background-color: #f3d19e;
  border-color: #f3d19e
}

.el-button--warning.is-plain {
  color: #E6A23C;
  background: #fdf6ec;
  border-color: #f5dab1
}

.el-button--warning.is-plain:focus,
.el-button--warning.is-plain:hover {
  background: #E6A23C;
  border-color: #E6A23C;
  color: #FFF
}

.el-button--warning.is-plain:active {
  background: #cf9236;
  border-color: #cf9236;
  color: #FFF;
  outline: 0
}

.el-button--warning.is-plain.is-disabled,
.el-button--warning.is-plain.is-disabled:active,
.el-button--warning.is-plain.is-disabled:focus,
.el-button--warning.is-plain.is-disabled:hover {
  color: #f0c78a;
  background-color: #fdf6ec;
  border-color: #faecd8
}

.el-button--danger {
  color: #FFF;
  background-color: #F56C6C;
  border-color: #F56C6C
}

.el-button--danger:focus,
.el-button--danger:hover {
  background: #f78989;
  border-color: #f78989;
  color: #FFF
}

.el-button--danger.is-active,
.el-button--danger:active {
  background: #dd6161;
  border-color: #dd6161;
  color: #FFF
}

.el-button--danger:active {
  outline: 0
}

.el-button--danger.is-disabled,
.el-button--danger.is-disabled:active,
.el-button--danger.is-disabled:focus,
.el-button--danger.is-disabled:hover {
  color: #FFF;
  background-color: #fab6b6;
  border-color: #fab6b6
}

.el-button--danger.is-plain {
  color: #F56C6C;
  background: #fef0f0;
  border-color: #fbc4c4
}

.el-button--danger.is-plain:focus,
.el-button--danger.is-plain:hover {
  background: #F56C6C;
  border-color: #F56C6C;
  color: #FFF
}

.el-button--danger.is-plain:active {
  background: #dd6161;
  border-color: #dd6161;
  color: #FFF;
  outline: 0
}

.el-button--danger.is-plain.is-disabled,
.el-button--danger.is-plain.is-disabled:active,
.el-button--danger.is-plain.is-disabled:focus,
.el-button--danger.is-plain.is-disabled:hover {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2
}

.el-button--info {
  color: #FFF;
  background-color: #909399;
  border-color: #909399
}

.el-button--info:focus,
.el-button--info:hover {
  background: #a6a9ad;
  border-color: #a6a9ad;
  color: #FFF
}

.el-button--info.is-active,
.el-button--info:active {
  background: #82848a;
  border-color: #82848a;
  color: #FFF
}

.el-button--info:active {
  outline: 0
}

.el-button--info.is-disabled,
.el-button--info.is-disabled:active,
.el-button--info.is-disabled:focus,
.el-button--info.is-disabled:hover {
  color: #FFF;
  background-color: #c8c9cc;
  border-color: #c8c9cc
}

.el-button--info.is-plain {
  color: #909399;
  background: #f4f4f5;
  border-color: #d3d4d6
}

.el-button--info.is-plain:focus,
.el-button--info.is-plain:hover {
  background: #909399;
  border-color: #909399;
  color: #FFF
}

.el-button--info.is-plain:active {
  background: #82848a;
  border-color: #82848a;
  color: #FFF;
  outline: 0
}

.el-button--info.is-plain.is-disabled,
.el-button--info.is-plain.is-disabled:active,
.el-button--info.is-plain.is-disabled:focus,
.el-button--info.is-plain.is-disabled:hover {
  color: #bcbec2;
  background-color: #f4f4f5;
  border-color: #e9e9eb
}

.el-button--medium {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 4px
}

.el-button--medium .el-input__inner {
  height: 36px;
  line-height: 36px
}

.el-button--medium .el-input__icon {
  line-height: 36px
}

.el-button--small {
  font-size: 13px
}

.el-button--small .el-input__inner {
  height: 32px;
  line-height: 32px
}

.el-button--small .el-input__icon {
  line-height: 32px
}

.el-button--mini {
  font-size: 12px
}

.el-button--mini .el-input__inner {
  height: 28px;
  line-height: 28px
}

.el-button--mini .el-input__icon {
  line-height: 28px
}

.el-button--text {
  border-color: transparent;
  color: #409EFF;
  background: 0 0;
  padding-left: 0;
  padding-right: 0
}

.el-button--text:focus,
.el-button--text:hover {
  color: #66b1ff;
  border-color: transparent;
  background-color: transparent
}

.el-button--text:active {
  color: #3a8ee6;
  border-color: transparent;
  background-color: transparent
}

.el-button--text.is-disabled,
.el-button--text.is-disabled:focus,
.el-button--text.is-disabled:hover {
  border-color: transparent
}

.el-button-group .el-button--danger:last-child,
.el-button-group .el-button--danger:not(:first-child):not(:last-child),
.el-button-group .el-button--info:last-child,
.el-button-group .el-button--info:not(:first-child):not(:last-child),
.el-button-group .el-button--primary:last-child,
.el-button-group .el-button--primary:not(:first-child):not(:last-child),
.el-button-group .el-button--success:last-child,
.el-button-group .el-button--success:not(:first-child):not(:last-child),
.el-button-group .el-button--warning:last-child,
.el-button-group .el-button--warning:not(:first-child):not(:last-child),
.el-button-group>.el-dropdown>.el-button {
  border-left-color: rgba(255, 255, 255, .5)
}

.el-button-group .el-button--danger:first-child,
.el-button-group .el-button--danger:not(:first-child):not(:last-child),
.el-button-group .el-button--info:first-child,
.el-button-group .el-button--info:not(:first-child):not(:last-child),
.el-button-group .el-button--primary:first-child,
.el-button-group .el-button--primary:not(:first-child):not(:last-child),
.el-button-group .el-button--success:first-child,
.el-button-group .el-button--success:not(:first-child):not(:last-child),
.el-button-group .el-button--warning:first-child,
.el-button-group .el-button--warning:not(:first-child):not(:last-child) {
  border-right-color: rgba(255, 255, 255, .5)
}

.el-button-group {
  display: inline-block;
  vertical-align: middle
}

.el-button-group::after,
.el-button-group::before {
  display: table;
  content: ""
}

.el-button-group::after {
  clear: both
}

.el-button-group>.el-button {
  float: left;
  position: relative
}

.el-button-group>.el-button+.el-button {
  margin-left: 0
}

.el-button-group>.el-button.is-disabled {
  z-index: 1
}

.el-button-group>.el-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0
}

.el-button-group>.el-button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0
}

.el-button-group>.el-button:first-child:last-child {
  border-radius: 4px
}

.el-button-group>.el-button:first-child:last-child.is-round {
  border-radius: 20px
}

.el-button-group>.el-button:first-child:last-child.is-circle {
  border-radius: 50%
}

.el-button-group>.el-button:not(:first-child):not(:last-child) {
  border-radius: 0
}

.el-button-group>.el-button:not(:last-child) {
  margin-right: -1px
}

.el-button-group>.el-button.is-active,
.el-button-group>.el-button:not(.is-disabled):active,
.el-button-group>.el-button:not(.is-disabled):focus,
.el-button-group>.el-button:not(.is-disabled):hover {
  z-index: 1
}

.el-button-group>.el-dropdown>.el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0
}

.el-input__inner,
.el-textarea__inner {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-image: none;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

.el-textarea {
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: bottom;
  font-size: 14px
}

.el-textarea__inner {
  display: block;
  resize: vertical;
  line-height: 1.5;
  box-sizing: border-box;
  border-radius: 12px;
  width: 100%;
  font-size: inherit;
  padding: 16px 16px 40px 16px;
  border: var(--style-border-always);
  min-height: 100px;
  color: var(--adil-fontcolor);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  background: var(--adil-card-bg);
  box-shadow: var(--adil-shadow-border);
}


@media screen and (max-width: 768px) {
  .el-textarea__inner {
    border-radius: 4px !important;
    background: var(--adil-card-bg) !important;
  }
}

.el-textarea__inner::-webkit-input-placeholder {
  color: #C0C4CC
}

.el-textarea__inner:-ms-input-placeholder {
  color: #C0C4CC
}

.el-textarea__inner::-ms-input-placeholder {
  color: #C0C4CC
}

.el-textarea__inner::placeholder {
  color: #C0C4CC
}

.el-textarea__inner:hover {
  border-color: #C0C4CC
}

.el-textarea__inner:focus {
  outline: 0;
  border: var(--style-border-hover-always) !important;
  box-shadow: var(--adil-shadow-main);
}

.el-textarea .el-input__count {
  color: var(--adil-secondtext);
  background: transparent !important;
  position: absolute;
  font-size: 12px;
  bottom: 5px;
  right: 10px
}

.el-textarea.is-disabled .el-textarea__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed
}

.el-textarea.is-disabled .el-textarea__inner::-webkit-input-placeholder {
  color: #C0C4CC
}

.el-textarea.is-disabled .el-textarea__inner:-ms-input-placeholder {
  color: #C0C4CC
}

.el-textarea.is-disabled .el-textarea__inner::-ms-input-placeholder {
  color: #C0C4CC
}

.el-textarea.is-disabled .el-textarea__inner::placeholder {
  color: #C0C4CC
}

.el-textarea.is-exceed .el-textarea__inner {
  border-color: #F56C6C
}

.el-textarea.is-exceed .el-input__count {
  color: #F56C6C
}

#twikoo.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100%
}

.el-input::-webkit-scrollbar {
  z-index: 11;
  width: 6px
}

.el-input::-webkit-scrollbar:horizontal {
  height: 6px
}

.el-input::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc
}

.el-input::-webkit-scrollbar-corner {
  background: #fff
}

.el-input::-webkit-scrollbar-track {
  background: #fff
}

.el-input::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px
}

.el-input .el-input__clear {
  color: #C0C4CC;
  font-size: 14px;
  cursor: pointer;
  -webkit-transition: color .2s cubic-bezier(.645, .045, .355, 1);
  transition: color .2s cubic-bezier(.645, .045, .355, 1)
}

.el-input .el-input__clear:hover {
  color: #909399
}

.el-input .el-input__count {
  height: 100%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #909399;
  font-size: 12px
}



.el-input-group__append .el-button,
.el-input-group__append .el-input,
.el-input-group__prepend .el-button,
.el-input-group__prepend .el-input,
.el-input__inner {
  font-size: inherit
}

.el-input .el-input__count .el-input__count-inner {
  background: #FFF;
  line-height: initial;
  display: inline-block;
  padding: 0 5px
}

#twikoo .el-input__inner {
  -webkit-appearance: none;
  appearance: none;
  background-color: #FFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%
}

.el-input__prefix,
.el-input__suffix {
  position: absolute;
  top: 0;
  transition: all .3s;
  text-align: center;
  height: 100%;
  color: #C0C4CC
}

.el-input__inner::-ms-reveal {
  display: none
}

.el-input__inner::-webkit-input-placeholder {
  color: #C0C4CC
}

.el-input__inner:-ms-input-placeholder {
  color: #C0C4CC
}

.el-input__inner::-ms-input-placeholder {
  color: #C0C4CC
}

.el-input__inner::placeholder {
  color: #C0C4CC
}

.el-input__inner:hover {
  border-color: #C0C4CC
}


.el-input-group__append,
.el-input-group__prepend {
  background-color: var(--adil-card-bg) !important;
  color: var(--adil-fontcolor) !important;
  border-color: var(--adil-card-border) !important;
  border: var(--style-border) !important;
  font-weight: bold;
  vertical-align: middle;
  display: table-cell;
  position: relative;
}

.el-input__suffix {
  right: 5px;
  transition: all .3s;
  pointer-events: none
}

.el-input__suffix-inner {
  pointer-events: all
}

.el-input__prefix {
  left: 5px;
  transition: all .3s
}

.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  -webkit-transition: all .3s;
  transition: all .3s;
  line-height: 40px
}

.el-input__icon:after {
  content: '';
  height: 100%;
  width: 0;
  display: inline-block;
  vertical-align: middle
}

.el-input__validateIcon {
  pointer-events: none
}

.el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed
}

.el-input.is-disabled .el-input__inner::-webkit-input-placeholder {
  color: #C0C4CC
}

.el-input.is-disabled .el-input__inner:-ms-input-placeholder {
  color: #C0C4CC
}

.el-input.is-disabled .el-input__inner::-ms-input-placeholder {
  color: #C0C4CC
}

.el-input.is-disabled .el-input__inner::placeholder {
  color: #C0C4CC
}

.el-input.is-disabled .el-input__icon {
  cursor: not-allowed
}

.el-input.is-exceed .el-input__inner {
  border-color: #F56C6C
}

.el-input.is-exceed .el-input__suffix .el-input__count {
  color: #F56C6C
}

.el-input--suffix .el-input__inner {
  padding-right: 30px
}

.el-input--prefix .el-input__inner {
  padding-left: 30px
}

.el-input--medium {
  font-size: 14px
}

.el-input--medium .el-input__inner {
  height: 36px;
  line-height: 36px
}

.el-input--medium .el-input__icon {
  line-height: 36px
}

.el-input--small {
  font-size: 13px
}

.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px
}

.el-input--small .el-input__icon {
  line-height: 32px
}

.el-input--mini {
  font-size: 12px
}

.el-input--mini .el-input__inner {
  height: 28px;
  line-height: 28px
}

.el-input--mini .el-input__icon {
  line-height: 28px
}

.el-input-group {
  line-height: normal;
  display: inline-table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0
}

.el-input-group>.el-input__inner {
  vertical-align: middle;
  display: table-cell
}



.el-input-group--prepend .el-input__inner,
.el-input-group__append {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0
}

.el-input-group--append .el-input__inner,
.el-input-group__prepend {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0
}

.el-input-group__append:focus,
.el-input-group__prepend:focus {
  outline: 0
}

.el-input-group__append .el-button,
.el-input-group__append .el-select,
.el-input-group__prepend .el-button,
.el-input-group__prepend .el-select {
  display: inline-block;
  margin: -10px -20px
}

.el-input-group__append button.el-button,
.el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner,
.el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: transparent;
  background-color: transparent;
  color: inherit;
  border-top: 0;
  border-bottom: 0
}

.el-input-group__prepend {
  border-right: 0
}

.el-input-group__append {
  border-left: 0
}

.el-input-group--append .el-select .el-input.is-focus .el-input__inner,
.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner {
  border-color: transparent
}

.el-input__inner::-ms-clear {
  display: none;
  width: 0;
  height: 0
}

.el-loading-parent--relative {
  position: relative !important
}

.el-loading-parent--hidden {
  overflow: hidden !important
}

.el-loading-mask {
  position: absolute;
  z-index: 2000;
  background-color: rgba(255, 255, 255, .9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity .3s;
  transition: opacity .3s
}

.el-loading-mask.is-fullscreen {
  position: fixed
}

.el-loading-mask.is-fullscreen .el-loading-spinner {
  margin-top: -25px
}

.el-loading-mask.is-fullscreen .el-loading-spinner .circular {
  height: 50px;
  width: 50px
}

.el-loading-spinner {
  top: 50%;
  margin-top: -21px;
  width: 100%;
  text-align: center;
  position: absolute
}

.el-loading-spinner .el-loading-text {
  color: #409EFF;
  margin: 3px 0;
  font-size: 14px
}

.el-loading-spinner .circular {
  height: 42px;
  width: 42px;
  -webkit-animation: loading-rotate 2s linear infinite;
  animation: loading-rotate 2s linear infinite
}

.el-loading-spinner .path {
  -webkit-animation: loading-dash 1.5s ease-in-out infinite;
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #409EFF;
  stroke-linecap: round
}

.el-loading-spinner i {
  color: #409EFF
}

.el-loading-fade-enter,
.el-loading-fade-leave-active {
  opacity: 0
}

@-webkit-keyframes loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg)
  }
}

@keyframes loading-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg)
  }
}

@-webkit-keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px
  }
}

/*!
 * OwO v1.0.2
 * Source: https://github.com/DIYgod/OwO/blob/master/dist/OwO.min.css
 * Author: DIYgod
 * Modified by: iMaeGoo
 * Released under the MIT License.
 */

.OwO {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.OwO.OwO-open .OwO-body {
  display: block;
}

.OwO .OwO-logo {
  width: 1.125em;
  display: flex;
}

.OwO .OwO-body {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  max-width: 500px;
  color: #4a4a4a;
  top: 2em;
  z-index: 1000;
  width: 500px;
  border: var(--style-border-always) !important;
  border-radius: 8px !important;
  overflow: hidden;
  background-color: var(--adil-maskbg) !important;
  backdrop-filter: saturate(180%) blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transform: translateZ(0);
}

.night .OwO .OwO-body,
.darkmode .OwO .OwO-body,
.DarkMode .OwO .OwO-body,
[data-theme="dark"] .OwO .OwO-body,
[data-user-color-scheme="dark"] .OwO .OwO-body {
  color: #ffffff;
  background-color: #4a4a4a;
}

.OwO .OwO-body .OwO-items {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: none;
  padding: 10px;
  padding-right: 0;
  margin: 0;
  overflow: auto;
  font-size: 0;
}

.OwO .OwO-body .OwO-items .OwO-item {
  list-style-type: none;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;
  font-size: 12px;
  line-height: 14px;
  cursor: pointer;
  -webkit-transition: .3s;
  transition: .3s;
  text-align: center;
}

.OwO .OwO-body .OwO-items .OwO-item:hover {
  background-color: rgba(144, 147, 153, 0.13);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.OwO .OwO-body .OwO-items-emoji .OwO-item {
  font-size: 20px;
  line-height: 19px;
}

.OwO .OwO-body .OwO-items-image .OwO-item {
  width: 14%;
  box-sizing: border-box;
}

@media screen and (max-width: 600px) {
  #twikoo .OwO-items>.OwO-item {
    width: 16%;
  }
}

@media screen and (max-width: 460px) {
  #twikoo .OwO-items>.OwO-item {
    width: 20%;
  }
}

@media screen and (max-width: 400px) {
  #twikoo .OwO-items>.OwO-item {
    width: 25%;
  }
}

@media screen and (max-width: 330px) {
  #twikoo .OwO-items>.OwO-item {
    width: 33%;
  }
}


.OwO .OwO-body .OwO-items-image .OwO-item img {
  max-width: 100%;
}

.OwO .OwO-body .OwO-items-show {
  display: block;
}

.OwO .OwO-body .OwO-bar {
  width: 100%;
  border-top: none;
  border-radius: 0 0 4px 4px;

}

.OwO .OwO-body .OwO-bar .OwO-packages {
  margin: 0;
  padding: 0;
  font-size: 0;
  background: var(--adil-background);
  padding-left: 8px;
}

.OwO .OwO-body .OwO-bar .OwO-packages li {
  list-style-type: none;
  display: inline-block;
  line-height: 30px;
  font-size: 14px;
  padding: 0 10px;
  cursor: pointer;
  margin-right: 3px;
}

.OwO .OwO-body .OwO-bar .OwO-packages li:nth-child(1) {
  border-radius: 0 0 0 3px;
}

.OwO .OwO-body .OwO-bar .OwO-packages li:hover {
  background-color: rgba(144, 147, 153, 0.13);
}

.OwO .OwO-body .OwO-bar .OwO-packages .OwO-package-active {
  background-color: var(--adil-secondbg);
  -webkit-transition: .3s;
  transition: .3s;
}


.tk-comments .el-button--primary.is-disabled:active,
.tk-comments .el-button--primary.is-disabled:focus,
.tk-comments .el-button--primary.is-disabled:hover {
  opacity: 0.4;
}

.tk-comments .el-button--primary {
  border-color: var(--adil-fontcolor) !important;
  color: var(--adil-card-bg) !important;
  border-radius: 4px !important;
  box-shadow: var(--adil-shadow-black);
  transition: 0.3s;
  width: 5rem;
  position: absolute;
  top: -53px;
  right: 0px;
  margin-left: 0.5rem !important;
  height: 32px;
}

.tk-icon.__comments:first-child {
  display: none;
}

.tk-comments-container>.tk-comment {
  padding: 1rem 1rem 1.5rem;
  border: var(--style-border);
  border-top: var(--style-border);
  box-shadow: var(--adil-shadow-border);
  margin-top: 0rem !important;
  margin-bottom: 0.5rem !important;
  background: var(--adil-card-bg);
  transition: 0.3s;
  border-radius: 12px;
}

@media screen and (max-width: 768px) {
  .tk-comments-container>.tk-comment {
    padding: 1rem;
    border: var(--style-border-always);
    box-shadow: var(--adil-shadow-border);
  }
  .tk-icon.__comments {
    left: 0.5rem;
  }
}
@media screen and (max-width: 768px) {
  .el-textarea__inner {
    border-radius: 4px !important;
    background: var(--adil-card-bg) !important;
  }
}
@media screen and (max-width: 768px) {
  .OwO .OwO-body {
    width: 300px;
  }
}
@media screen and (max-width: 768px) {
  .tk-submit .el-button--primary {
    width: 5rem;
    height: 122px;
    top: -132px;
  }

  .tk-row-actions-start {
    top: -170px;
  }
}
@media screen and (max-width: 768px) {
  .tk-comments-container > .tk-comment {
    padding: 1rem;
    border: var(--style-border-always);
    box-shadow: var(--adil-shadow-border);
  }

  .tk-icon.__comments {
    left: 0.5rem;
  }
}
@media screen and (max-width: 768px) {
  .tk-meta-input .el-input .el-input-group__prepend {
    padding: 0 0.3rem !important;
  }

  .tk-meta-input {
    display: flex;
    flex-direction: column;
    top: 0;
    position: inherit !important;
  }

  .tk-meta-input .el-input {
    margin-left: 0 ;
    width: 100% ;
  }

  .tk-icon {
    position: absolute;
    right: 0;
  }
  .el-textarea__inner {
    background: var(--adil-card-bg) !important;
  }
}

</style>